import type { HexColorString, RgbColorString } from '@@fire-base/types/utils/ColorString'

export function hexToRgb(hex: HexColorString): { r: number; g: number; b: number } | undefined {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)

  if (result && result.length > 3) {
    return {
      r: parseInt(result[1]!, 16),
      g: parseInt(result[2]!, 16),
      b: parseInt(result[3]!, 16),
    }
  }

  return undefined
}

export function rgbToString(rgb: { r: number; g: number; b: number } | undefined): RgbColorString | undefined {
  if (!rgb) {
    return undefined
  }
  return `${rgb.r}, ${rgb.g}, ${rgb.b}`
}

export function hexToRgbString(hex: HexColorString): RgbColorString | undefined {
  return rgbToString(hexToRgb(hex))
}
